// src/App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import { theme } from './styles/theme';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ServicePage from './pages/services/ServicePage';
import AboutUs from './pages/AboutUs';
import Contact from './pages/Contact';

const Home = lazy(() => import('./pages/Home'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Crew = lazy(() => import('./pages/Crew'));

const LoadingFallback = () => (
  <div style={{ 
    height: '100vh', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center' 
  }}>
    Loading...
  </div>
);

const ErrorFallback = () => (
  <div>
    <h1>Oops, something went wrong!</h1>
    <p>Please try again later.</p>
  </div>
);

const App = () => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <Router>
      <ScrollToTop />
      <Header />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/crew" element={<Crew />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="*" element={<ErrorFallback />} />
        </Routes>
      </Suspense>
      <Footer />
    </Router>
  </ThemeProvider>
);

export default App;